
import { Toast } from 'vant';
import { Message } from 'element-ui';

var w=window.innerWidth
|| document.documentElement.clientWidth
|| document.body.clientWidth;

var flag = w > 768 ? false :true;

import { MessageBox } from 'element-ui';
import {
    Dialog
} from 'vant';

export default {
	shapeprice:0,//楦头价格  默认楦头不收费 改变楦头收费
	technologyArr:[
		{
	       label:"Print($0)",
	       id:1,
	       price:0,
	       value:"Print"
		},
		{
	       label:"Stitch($0)",
	       id:2,
	       price:0,
	       value:"Stitch"
		},
	],
	technologyArr2:[{
			label: "Print",
			id: 1,
			price:0,
			value: "Print"
		},
		{
			label: "Stitch",
			id: 2,
			price: 0,
			value: "Stitch"
		},
	],
	// 自定义图片价格
	options: [
	// 	{  
	// 	value: '1',
	// 	label: 'Monochrome($400)',
	// 	price:400
	// }, {
	// 	value: '2',
	// 	label: 'Bicolor($800)',
	// 	price:800
	// }, 
	{
		value: '1',
		label: 'Multicolor($0)'
	}],
    dialogConfirm:function(e){
        if (flag) {
        	
			return Dialog.confirm({
				title: e.title,
				message: e.message,
			})

		} else {
                 

			return MessageBox(e.message, e.title, {
				confirmButtonText:e.confirmButtonText?e.confirmButtonText: 'Confim',
				cancelButtonText:e.cancelButtonText?e.cancelButtonText:'Cancel',
				type: 'warning'
			})
		}
	},
	isWeiXin() {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true; // 是微信端
        } else {
            return false;
        }
    },
    _isMobile() {
		 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		 return flag;
	},
	showWranToast:function(msg){
        if(flag){
		    Toast.fail(msg);
		}else{
			Message({
				message: msg,
				type: 'warning'
			});
		}
	},
	showToast:function(msg){
        if(flag){
		   Toast.success(msg);
		}else{
			Message({
				message: msg,
				type: 'success'
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/js/global_variable.js